// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { 
  getFirestore, 
  doc, 
  getDoc,
  collection,
  query,
  where,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  enableIndexedDbPersistence,
  setLogLevel
} from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCiRMPc5Ttq6jEBSHdgBu2EQQT3O1Kqxhg",
  authDomain: "llama-e35e0.firebaseapp.com",
  projectId: "llama-e35e0",
  storageBucket: "llama-e35e0.appspot.com",
  messagingSenderId: "228136721867",
  appId: "1:228136721867:web:860aa3299c6508c63fea4e"
};

// Initialize Firebase with error handling
let app;
let auth;
let db;
let storage;

try {
  // Initialize Firebase app
  console.log('Initializing Firebase app...');
  app = initializeApp(firebaseConfig);
  console.log('Firebase app initialized successfully');

  // Initialize Firebase Authentication
  auth = getAuth(app);
  console.log('Firebase Auth initialized');
  
  // Initialize Cloud Firestore
  db = getFirestore(app);
  console.log('Firestore initialized');
  
  // Initialize Cloud Storage
  storage = getStorage(app);
  console.log('Firebase Storage initialized');
  
  // Enable offline persistence for Firestore
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Offline persistence can only be enabled in one tab at a time.');
    } else if (err.code === 'unimplemented') {
      console.warn('The current browser doesn\'t support offline persistence.');
    }
  });
  
  // Set log level for debugging (optional)
  setLogLevel('error');
  
  console.log('Using production Firebase services');
  
  // Test the connection
  const testConnection = async () => {
    try {
      const testDoc = doc(db, 'test', 'connection');
      await setDoc(testDoc, { test: new Date().toISOString() }, { merge: true });
      console.log('Firebase connection test: SUCCESS');
      return true;
    } catch (error) {
      console.error('Firebase connection test: FAILED', error);
      return false;
    }
  };
  
  // Run the test connection
  testConnection().then(success => {
    if (success) {
      console.log('Firebase services are ready to use');
    } else {
      console.warn('Firebase connection test failed, some features may not work as expected');
    }
  });
  
} catch (error) {
  console.error('Firebase initialization error:', error);
  throw new Error(`Failed to initialize Firebase: ${error.message}`);
}

// Export the initialized services
export { app, auth, db, storage };

// Export common Firestore functions for easier imports
export {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp
};

// Export the test function
export const testFirebaseConnection = async () => {
  try {
    console.log('Testing Firebase connection...');
    
    // Test Firestore connection
    const testDoc = doc(db, 'test', 'connection');
    const docSnap = await getDoc(testDoc);
    console.log('Firestore connection test:', docSnap.exists() ? 'Document exists' : 'Document does not exist (but connection successful)');
    
    // Test Auth connection
    console.log('Auth connection test: Current user is', auth.currentUser ? 'authenticated' : 'not authenticated');
    
    // Test Storage connection
    const storageRef = ref(storage, 'test.txt');
    console.log('Storage connection test: Reference created successfully');
    
    return {
      firestore: true,
      auth: true,
      storage: true,
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Firebase connection test failed:', error);
    throw error;
  }
};

// Run connection test on import
// Note: This will run when the module is imported
testFirebaseConnection().then(success => {
  if (success) {
    console.log('Firebase connection test completed successfully');
  } else {
    console.error('Firebase connection test failed');
  }
});
